<template lang="html">

  <section class="footer">
<!--     {{$t('enlaces.contacto')}}
    <idioma></idioma> -->
  </section>

</template>

<script lang="js">

  import idioma from '@/components/view-parts/footer/idioma'

  export default  {
    name: 'app-footer',
    props: [],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {
        
    },
    components: {
      'idioma' : idioma
    }
}
</script>

<style scoped>
  .footer {

  }
</style>



// WEBPACK FOOTER //
// src/components/parts/footer.vue